const handleAccordions = () => {
    const $accordion = $('.js-accordion');
    const $accordionTrigger = $accordion.find('.accordion__head');

    //Handle the show/hide logic
    $accordionTrigger.on('click', function(event) {
        $(this).next().stop().slideToggle()
            .parent().toggleClass('is-active')
            .siblings().removeClass('is-active')
            .find('.accordion__body').slideUp();
    });
};

handleAccordions();

$(function() {

    $('#product-form-wrapper').on('submit', function(e) {
        e.preventDefault();
        var selected_id = $('[name="id"]').val();
        $('.js-add-to-cart-text').text('Adding');

        var properties = {};

        if($('.product__sizes').length){
            var selected_size = $('.product__sizes input[type=radio]:checked').val();

            properties['size'] = selected_size;
        }

        if($('.product__options').length){

            $( ".product__options" ).each(function( index ) {
                var the_title = $(this).data('name');
                var selected_size = $(this).find('input[type=radio]:checked').val();
               properties[the_title] = selected_size;
      
            });

        }

        CartJS.addItem(selected_id, 1, properties, {
            "success": function(data, textStatus, jqXHR) {
                $('body').addClass('js-show-cart');
                $('.js-add-to-cart-text').text('ADD TO CART');
            },
            "error": function(data, textStatus, jqXHR) {
                $('.js-add-to-cart-text').text('ADD TO CART');
            } 
        });
    });

});